import React, { useEffect } from "react";
import FilterGroup from "./FilterGroup";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchFilters,
  updateFiltersBySearchParams,
} from "../../redux/filters/filterSlice";
import { setLoaderState } from "../../redux/loader/loaderSlice";

function Filters() {
  const dispatch = useDispatch();
  const filterItems = useSelector((state) => state.filters.items);
  const loadingStatus = useSelector((state) => state.filters.status);
  const isUpdatedFromUrl = useSelector(
    (state) => state.filters.isUpdatedFromUrl
  );
  const dictionary = useSelector((state) => state.localization.dictionary);

  useEffect(() => {
    dispatch(fetchFilters());
  }, []);

  useEffect(() => {
    if (loadingStatus === "loading") {
      dispatch(setLoaderState(true));
    }

    if (loadingStatus === "resolved") {
      dispatch(setLoaderState(false));
      if (!isUpdatedFromUrl) {
        dispatch(updateFiltersBySearchParams());
      }
    }

    if (loadingStatus === "rejected") {
      dispatch(setLoaderState(false));
    }
  }, [loadingStatus]);

  return (
    <>
      <a href="#story-0" className="accessibility-link">
        {dictionary["CNHS.Filter.SkipFilters"]}
      </a>
      <div id="filters">
        {filterItems.map((filterGroup, index) => (
          <FilterGroup
            filterGroup={filterGroup}
            key={`filter-group-${index}`}
          />
        ))}
      </div>
    </>
  );
}

export default Filters;
